import React from "react";
import "./CookieBanner.css";
import { connect } from "react-redux";
import {
  mapStateToPropsCookieConsent,
  mapDispatchToPropsCookieConsent,
} from "../../../modules/cookieConsent";
import { mapDispatchToPropsLayout } from "../../../modules/layout";

const CookieBanner = (props) => {
  const { acceptCookieFunction, isCookiesAccepted } = props;

  const closeCookieBanner = (e) => {
    e.preventDefault();
    acceptCookieFunction();
  };

  return (
    <>
      {!isCookiesAccepted && (
        <div className="consent-banner">
          <p>
            This site uses cookies to provide you with a more responsive and
            personalized service. By clicking "Accept" below, you agree to the
            use of cookies on this site. Please read our{" "}
            <a
              href="https://www.ultragenyx.com/cookie-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="block__link small-link"
            >
              Cookie Policy
            </a>{" "}
            and{" "}
            <a
              href="https://www.ultragenyx.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="block__link small-link"
            >
              Privacy Policy
            </a>{" "}
            for more information on the use of cookies on this website.
          </p>
          <div className="consent-banner-btn-container">
            <button
              className="btn btn-primary ultra-shadow btn-sm"
              onClick={closeCookieBanner}
            >
              Accept
            </button>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    ...mapStateToPropsCookieConsent(state),
  };
};

const mapDispatchToProps = {
  ...mapDispatchToPropsCookieConsent,
  ...mapDispatchToPropsLayout,
};

export default connect(mapStateToProps, mapDispatchToProps)(CookieBanner);
